import React from 'react'
import ComponentStyle from '../styles/Components.module.css'

function Facebook() {
  return (
    <div className={`${ComponentStyle.title}`}><h1>Facebook</h1></div>
  )
}

export default Facebook